import script from "./ToastHost.vue?vue&type=script&setup=true&lang=js"
export * from "./ToastHost.vue?vue&type=script&setup=true&lang=js"

import "./ToastHost.vue?vue&type=style&index=0&id=a494e290&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a494e290"]])

export default __exports__